import { useTheme } from "@emotion/react"
import { Chip } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function NewTabChip() {
    const theme = useTheme()

    return (
        <Chip
            label="New"
            size="small"
            data-cy="new-tab-chip"
            sx={{
                px: 2,
                py: 1,
                textTransform: "none",
                color: theme.palette.success.main,
                backgroundColor: theme.palette.primary.main + "20",
            }}
            icon={<Iconify icon="mingcute:ai-line" fontSize="small" color={theme.palette.success.main} />}
        />
    )
}
